import { imageCoverContainer } from '@helpers/aspectRatio';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, h1 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --textColor: var(--fgColor);
  --blur: 0px;
  --tint: 0.5;

  position: relative;
  color: var(--textColor);
  overflow: hidden;  

  &[data-spacing='margin'] {
    margin-top: 0;
    margin-bottom: 0;
  }

  &[data-contains-image='true'] {
    --textColor: var(--bgColor);
  }
`;
const ContentWrapper = styled.div `
  display: grid;
  margin-bottom: calc(var(--indicatorSize) * -1);
`;
const Inner = styled.div `
  display: flex;
  flex-direction: column;
  padding: ${fluid(32, 64)} 0;
  color: var(--textColor);
  position: relative;

  ${Container}[data-contains-image='true'] & {
    padding-top: 6.7%;
    padding-bottom: 6.7%;
  }

  @media ${from(Device.TabletSmall)} {
    justify-content: center;
  }
`;
const Tagline = styled.span `
  ${fonts.cabin.regular};
  font-size: ${fluid(16, 18)};
  line-height: ${fluid(20, 22)};
  margin-bottom: 5px;
`;
const Title = styled.h1 `
  ${h1};
  font-size: ${fluid(28, 42)};
  line-height: clamp(1.2rem, 1.6rem + 3vw, 3rem);
  margin: 0;

  @media ${from(Device.TabletSmall)} {
    max-width: 24ch;
  }
`;
const Content = styled.div `
  font-size: ${fluid(18, 22)};
  line-height: ${fluid(27, 33)};
  
  ${contentStyles};

  max-width: 80ch;
  padding-top: 24px;

  p {
    font-size: ${fluid(18, 22)};
    line-height: ${fluid(27, 33)};
  }

  @media ${from(Device.TabletLarge)} {
    padding-top: 32px;
    max-width: 60%;
  }
`;
const CtaWrapper = styled.div `
  margin-top: 30px;
`;
const ImageWrapper = styled.div `
  position: absolute;
  top: calc(var(--blur) * -4);
  left: calc(var(--blur) * -4);
  height: calc(100% + (var(--blur) * 8));
  filter: blur(var(--blur)) brightness(calc(1 - var(--tint)));
  margin: calc(var(--blur) * -1);
  width: calc(100% + (var(--blur) * 8));
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const Overlay = styled.div `
  ${siteWide};

  height: 100%;
  position: relative;

  &::before {
    content: '';
    width: 50%;
    height: 100%;
    display: block;
    position: absolute;
    background-color: hsla(var(--bgColorString) / 0.2);
    transform: translateX(50%) skewX(-26.65deg);
    top: 0;
    right: 0;

    @media ${from(Device.Tablet)} {
      width: 27.5%;
      transform: skewX(-26.65deg);
    }
  }
`;
const Date = styled.time `
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  padding-top: 10px;
  margin-bottom: 5px;
  display: block;
`;
const TypeList = styled.div `
  display: flex;
`;
const TypeItem = styled.span `
  font-weight: 700;
  flex: 0 0 auto;
  margin-right: 15px;
  margin-bottom: 5px;
  font-size: 14px;
`;
const InnerPageHeroStyles = {
    Container,
    Content,
    ContentWrapper,
    CtaWrapper,
    Date,
    Image,
    ImageWrapper,
    Inner,
    Overlay,
    Tagline,
    Title,
    TypeItem,
    TypeList,
};
export default InnerPageHeroStyles;
